import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class FictionExtra extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fictionAreaList, fictionAreaBox },
        } = this.props;

        return (
            <Fragment>
                <Chip
                    id="225818"
                    type="recommend"
                    title="其他地区小说列表"
                    groupName="小说"
                    content={fictionAreaList}
                    translate="handleNewsData">
                    <NewsList hasTitle size="long" />
                </Chip>
                <Chip
                    id="225819"
                    type="recommend"
                    title="其他地区小说新闻盒"
                    groupName="小说"
                    content={fictionAreaBox}
                    translate="handleNewsBoxData">
                    <NewsBox />
                </Chip>
            </Fragment>
        );
    }
}

export default errorBoundary(FictionExtra);
